import Vue from 'vue';

/**
 * Class Auth Service
 */
export default class AuthService extends Vue {

    private customActions = {
        insight: { method: 'GET', url: 'auth/insight/{platform_id}' },
        change_password: { method: 'POST', url: 'auth/change_password' },
        setGeneralData: { method: 'POST', url: 'auth/general-data' },
        getGeneralData: { method: 'GET', url: 'auth/general-data/{idUser}/{idPlatform}' },
        passwordRecovery: { method: 'POST', url: 'auth/password-recovery' },
    };
    private resource: any = this.$resource('auth/insight{/id}', {}, this.customActions);

    // GET platform insight
    public show(id: number) {
        return this.resource.get({ id }).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    // POST change password
    public change_password(data: any) {
        return this.resource.change_password({}, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
    
    // POST change configs
    public setGeneralData(data: any) {
        return this.resource.setGeneralData({}, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    // GET configs
    public getGeneralData(idUser:any, idPlatform:any) {
        return this.resource.getGeneralData({idUser, idPlatform}).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    // POST password recovery
    public passwordRecovery(data: any) {
        return this.resource.passwordRecovery({}, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
